import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../axios';
import { updateToastData } from '../toasterSlice';
import { ERROR, SUCCESS } from '../../components/Common/Const';
export const addClientSocketToDb = createAsyncThunk(
    'clientSocket/addClientSocket',
    async (clientSocketData, { rejectWithValue, dispatch }) => {
        try {
            const response = await axiosInstance.post('/admin/clientSocket/save', clientSocketData);
            dispatch(updateToastData({ data: response?.message, title: response?.title, type: SUCCESS }));
            return response?.result;
        } catch (error) {
            dispatch(updateToastData({ data: error?.message, title: error?.title, type: ERROR }));
            return rejectWithValue(error?.message);
        }
    }
);

const clientSocketSlice = createSlice({
    name: 'clientSocket',
    initialState: {
        isSaved: undefined,
        isLoading: false,
        error: null,
    },
    reducers: {
        updateSavedState: (state, action) => {
            state.isSaved = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(addClientSocketToDb.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(addClientSocketToDb.fulfilled, (state, action) => {
                state.isSaved = true
                state.isLoading = false;
            })
            .addCase(addClientSocketToDb.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            });
    }
});

export const { updateSavedState } = clientSocketSlice.actions;
export default clientSocketSlice.reducer;
